/**
 * Wires the nav overlay trigger button to show/hide the level-select overlay.
 * Manages body scroll lock and focus trapping.
 */

const TRIGGER_SELECTOR = "[data-nav-overlay-trigger]"
const OVERLAY_ID = "nav-overlay"

/** @type {HTMLElement|null} */
let previousFocus = null

/**
 * Show the overlay and lock body scroll.
 * @param {HTMLElement} overlay
 */
function openOverlay(overlay) {
  previousFocus = document.activeElement
  overlay.showCardForPath(window.location.pathname)
  overlay.setAttribute("open", "")
  document.body.style.overflow = "hidden"
  const closeBtn = overlay.shadowRoot?.querySelector(".close-btn")
  ;(closeBtn ?? overlay).focus()
}

/**
 * Hide the overlay and restore body scroll.
 * @param {HTMLElement} overlay
 */
function closeOverlay(overlay) {
  overlay.removeAttribute("open")
  document.body.style.overflow = ""
  if (previousFocus) {
    previousFocus.focus()
    previousFocus = null
  }
}

function init() {
  const trigger = document.querySelector(TRIGGER_SELECTOR)
  const overlay = document.getElementById(OVERLAY_ID)
  if (!trigger || !overlay) return

  trigger.addEventListener("click", () => openOverlay(overlay))

  overlay.addEventListener("close-overlay", () => closeOverlay(overlay))

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && overlay.hasAttribute("open")) {
      closeOverlay(overlay)
    }
  })
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init)
} else {
  init()
}
